// Cena 9 — Usuários (áudio ~20s)
// O cursor clica no botão REAL de novo usuário, o modal grande centralizado
// abre com nome e email digitando sozinhos, o cursor aponta perfil e filas
// enquanto a narração explica, salva e a Ana aparece na lista da equipe.
const MAIN = "[data-tour='main-content']";
const BTN_ADD = "[data-tour='btn-add-user']";
const MODAL = "[data-demo='modal']";
const SAVE = "[data-demo='save']";

export default async function users(ctx) {
	// "Em Usuários você monta o seu time!" — destaque no botão real
	await ctx.wait(400);
	await ctx.waitFor(BTN_ADD);
	ctx.spotlight(BTN_ADD);
	await ctx.cursorTo(BTN_ADD, { duration: 900 });
	await ctx.wait(450);
	await ctx.click(BTN_ADD);
	ctx.spotlight(null);
	await ctx.wait(300);

	// "Cadastre cada atendente com nome e email…" — modal centralizado,
	// campos digitando sozinhos (o próprio modal ativa o blur de fundo)
	const modal = ctx.mount("formModal", MAIN, {
		title: "Novo usuário",
		fields: [
			{ label: "Nome", value: "Ana Lima", done: false },
			{ label: "Email", value: "ana@flytec.com", done: false },
			{ label: "Perfil", value: "Usuário (atendente)", done: true },
			{ label: "Filas", value: "Vendas", done: true },
		],
		saving: false,
	});
	await ctx.waitFor(MODAL);
	await ctx.wait(3400);

	// "escolha o perfil: administrador vê tudo, usuário foca nos atendimentos"
	await ctx.cursorTo({ sel: MODAL, ax: 0.5, ay: 0.58 }, { duration: 750 });
	await ctx.wait(3000);

	// "e vincule cada pessoa às filas dela"
	await ctx.cursorTo({ sel: MODAL, ax: 0.5, ay: 0.75 }, { duration: 650 });
	await ctx.wait(2200);

	// salvar
	await ctx.waitFor(SAVE);
	await ctx.cursorTo(SAVE, { duration: 700 });
	await ctx.click(SAVE);
	ctx.update(modal, { saving: true });
	await ctx.wait(900);
	ctx.unmount(modal);
	await ctx.wait(350);

	// "Trabalho em equipe do jeito certo!" — Ana entra na lista
	ctx.mount("userRow", MAIN, {
		name: "Ana Lima",
		email: "ana@flytec.com",
		initial: "A",
		color: "#F59E0B",
		profile: "Atendente",
		queue: "Vendas",
		style: { position: "absolute", top: 130, left: 24, width: 440 },
	});
	await ctx.cursorTo({ sel: MAIN, ax: 0.22, ay: 0.24 }, { duration: 700 });
	await ctx.wait(300);

	const toast = ctx.mount("toast", MAIN, {
		icon: "🤝",
		text: "Time montado!",
	});
	await ctx.wait(2200);
	ctx.unmount(toast);
}
